/**
 * Created by AlexanderC on 12/8/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rfc = require('./rfc3986');

var _rfc2 = _interopRequireDefault(_rfc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  createUriRegex: optionalScheme => {
    let scheme = _rfc2.default.scheme;

    // If we were passed a scheme, use it instead of the generic one
    if (optionalScheme) {

      // Have to put this in a non-capturing group to handle the OR statements
      scheme = '(?:' + optionalScheme + ')';
    }

    /**
     * URI = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
     */
    return new RegExp(`^${scheme}:${_rfc2.default.hierPart}(?:\\?${_rfc2.default.query})?(?:#${_rfc2.default.fragment})?$`);
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Helpers/uriRegexp.js
// module id = 462
// module chunks = 0